import {
  TaxesCreateBody,
  TaxesListResponse,
  TaxesItem,
  TaxesDetailResponse,
} from "utils/api/client/types"

export class Taxes {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }
  create(
    vendorId: string,
    body: TaxesCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<TaxesItem> {
    return (async () => {
      return await (this.client as any).fetch(`/vendor/${vendorId}/taxes`, {
        method: "POST",
        headers,
        body,
        query,
      })
    })()
  }

  update(
    id: string,
    vendorId: string,
    body: TaxesCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<TaxesItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/taxes/${id}`,
        {
          method: "PUT",
          headers,
          body,
          query,
        }
      )
    })()
  }

  list(
    vendorId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<TaxesListResponse> {
    return (async () => {
      return await (this.client as any).fetch(`/vendor/${vendorId}/taxes`, {
        headers,
        query: queryParams,
      })
    })()
  }

  retrieve(
    id: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<TaxesDetailResponse> {
    return (async () => {
      const { vendorId, ...reset } = queryParams as any
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/taxes/${id}`,
        {
          query: reset,
          headers,
        }
      )
    })()
  }

  delete(
    id: string,
    vendorId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/taxes/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }
}
